import styled from 'styled-components';
import CardV2Wrapper from '../../../v2/components/GDS/CardV2';

export const MainContentCmsContainer = styled.div`
  padding: 12px;
  flex: 1;
  overflow: auto;
`;

export const StyledProductCard = styled(CardV2Wrapper)`
  width: 100%;
`;
